// Constants
const COOKIE_EXPIRY_DAYS = 30;
const MESSAGE_EXPIRY_DAYS = 30;
const userShareLocation = document.querySelector(".banner-localization");
const userShareLocationButton = document.querySelector(
	".banner-localization__button",
);
const userShareLocationError = document.querySelector(
	".banner-localization__error",
);
let firstRun = true;
let clicked = false;
let shared = false;

// Helpers
const setCookie = async (name, value, days) => {
	const expiryDate = new Date();
	expiryDate.setDate(expiryDate.getDate() + days);
	await cookieStore.set({
		name: name,
		value: value,
		expires: expiryDate,
	});
};

const getCookie = async (name) => {
	const cookie = await cookieStore.get(name);
	return cookie ? cookie.value : null;
};

const getStates = async () => {
	const response = await fetch("/api/core/states/?country=1", {
		method: "GET",
	});
	if (!response.ok) {
		console.log("error");
	}
	return response.json();
};

function normalizeString(str) {
	return str
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/\s+/g, " ")
		.trim();
}

const getProvinceFromCoordinates = async (latitude, longitude) => {
	try {
		const response = await fetch(
			`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
		);
		const data = await response.json();
		const states = await getStates();
		// Extract province/state from the address
		const province = data.address.state || data.address.province;
		const state = states.find(
			(state) => normalizeString(state.name) === normalizeString(province),
		);

		return { id: state?.id || province, name: province };
	} catch (error) {
		console.error("Error getting province from coordinates:", error);
		return null;
	}
};

const handleLocationSuccess = async (position) => {
	const { latitude, longitude } = position.coords;
	const province = await getProvinceFromCoordinates(latitude, longitude);
	const cookieData = {
		province: province.id,
		date: new Date().toISOString(),
	};
	await setCookie(
		"sullair-localization",
		JSON.stringify(cookieData),
		COOKIE_EXPIRY_DAYS,
	);
	if (province && !shared) {
		if (window.dataLayer) {
			window.dataLayer.push({
				event: "compartir_ubicacion",
				eventLabel: clicked ? "banner" : "directo",
				province_name: province.name,
			});
			shared = true;
		}
		window.location.reload();
	}
	firstRun = false;
};

const handleLocationError = (_error) => {
	if (userShareLocationError && !firstRun) {
		userShareLocationError.classList.remove("hidden");
		setTimeout(() => {
			userShareLocationError.classList.add("hidden");
		}, 5000);
	}
	firstRun = false;
};

const promtUserLocation = async ({ eventLabel = "banner_view" }) => {
	// Check if we already have a province cookie
	const messageCookie = await getCookie("sullair-localization");
	const shouldRequestLocation =
		!messageCookie ||
		(() => {
			const cookieData = JSON.parse(messageCookie);
			const province = cookieData.province;
			if (province) {
				userShareLocation.remove();
				return false;
			}

			const date = new Date(cookieData.date);
			const diffDays = Math.ceil(
				Math.abs(Date.now() - date) / (1000 * 60 * 60 * 24),
			);
			return diffDays > MESSAGE_EXPIRY_DAYS;
		})();

	if (shouldRequestLocation && navigator.geolocation) {
		if (window.dataLayer) {
			window.dataLayer.push({
				event: "banner_geolocalizacion",
				eventLabel: eventLabel,
			});
		}
		navigator.geolocation.getCurrentPosition(
			handleLocationSuccess,
			handleLocationError,
		);
	} else {
		userShareLocation.remove();
	}
};

if (userShareLocation && userShareLocationButton) {
	promtUserLocation({ eventLabel: "banner_view" });

	userShareLocationButton.addEventListener("click", (e) => {
		e.preventDefault();
		clicked = true;
		promtUserLocation({ eventLabel: "banner_click_compartir" });
	});
}
